<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <h3 class="card-title">会員情報</h3>
          </CCardHeader>
          <CCardBody class="profile-home px-5">
            <div class="user-info-table mx-2">
              <dl class="row">
                <dt class="col-sm-12">
                  <h4 class="sub-title">登録情報</h4>
                </dt>
              </dl>
              <dl class="row r-content">
                <dd class="col-sm-8">
                  <dl class="row sub-r-content">
                    <dt class="col-sm-3">ユーザー名</dt>
                    <dd class="col-sm-9">{{ user.name }}</dd>
                    <dt class="col-sm-3">カードID</dt>
                    <dd class="col-sm-9">{{ user.cardId }}</dd>
                    <dt class="col-sm-3">氏名</dt>
                    <dd class="col-sm-9">{{ fullName }}</dd>
                    <dt class="col-sm-3">氏名（カナ）</dt>
                    <dd class="col-sm-9">
                      {{ user.lastName }} {{ user.firstName }}
                    </dd>
                    <dt class="col-sm-3">性別</dt>
                    <dd class="col-sm-9">{{ user.gender | genderString }}</dd>
                    <dt class="col-sm-3">生年月日</dt>
                    <dd class="col-sm-9" v-if="user.birth">
                      {{ user.birth | formatDate }}
                    </dd>
                    <dd class="col-sm-9" v-if="!user.birth"></dd>
                    <!-- <dt class="col-sm-3">プロフィール画像</dt>
                    <dd class="col-sm-9">
                      <img class="avatar-img" :src="avatar.image" />
                    </dd> -->
                  </dl>
                </dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-12">
                  <h4 class="sub-title">連絡情報</h4>
                </dt>
              </dl>
              <dl class="row r-content">
                <dd class="col-sm-8">
                  <dl class="row sub-r-content">
                    <dt class="col-sm-3">Eメールアドレス</dt>
                    <dd class="col-sm-9">{{ user.email }}</dd>
                    <!-- <dt class="col-sm-3">Eメールアドレス承認状態</dt>
                    <dd class="col-sm-9">
                      {{ user.emailVerified | emailVerifiedString }}
                    </dd> -->
                    <dt class="col-sm-3">電話番号</dt>
                    <dd class="col-sm-9">
                      {{ user.countryCode }} {{ user.mobile }}
                    </dd>
                  </dl>
                </dd>
              </dl>
              <dl class="row">
                <dt class="col-sm-12">
                  <h4 class="sub-title">住所</h4>
                </dt>
              </dl>
              <dl class="row r-content">
                <dd class="col-sm-8">
                  <dl class="row sub-r-content">
                    <dt class="col-sm-3">国</dt>
                    <dd class="col-sm-9">{{ user.address.country.name }}</dd>
                    <dt class="col-sm-3">郵便番号</dt>
                    <dd class="col-sm-9">{{ user.address.zipCode }}</dd>
                    <dt class="col-sm-3">都道府県</dt>
                    <dd class="col-sm-9">{{ user.address.state }}</dd>
                    <dt class="col-sm-3">市区町村</dt>
                    <dd class="col-sm-9">{{ user.address.city }}</dd>
                    <dt class="col-sm-3">地番番地</dt>
                    <dd class="col-sm-9">{{ user.address.address1 }}</dd>
                    <dt class="col-sm-3">建物・その他</dt>
                    <dd class="col-sm-9">{{ user.address.address2 }}</dd>
                  </dl>
                </dd>
              </dl>
            </div>
          </CCardBody>
          <CCardFooter class="px-5">
            <CButton class="info-button" @click="openEditDialog()"
              ><i class="icon cil-pencil"></i> 編集</CButton
            >
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="securityRecetBox mb-5">
      <CCol lg="6">
        <CCard>
          <CCardHeader>
            <h3 class="card-title">Eメールアドレス更新</h3>
          </CCardHeader>
          <CCardBody class="px-5">
            <CAlert show color="info"
              >新しいEメールアドレスを入力してください。</CAlert
            >
            <CForm class="member-info modal-form">
              <CRow>
                <CCol lg="12">
                  <CInput
                    type="email"
                    label="新Eメールアドレス"
                    horizontal
                    v-model="newEmail"
                  />

                  <CAlert
                    show
                    color="danger"
                    v-if="$v.newEmail.$dirty && !$v.newEmail.required"
                  >
                    新Eメールアドレスは必須です
                  </CAlert>
                  <CAlert
                    show
                    color="danger"
                    v-if="
                      $v.newEmail.$dirty && !$v.newEmail.alphaEmailValidator
                    "
                  >
                    メールの形式が正しくありません。
                  </CAlert>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
          <CCardFooter class="px-5">
            <CButton
              class="info-button shadow-sm"
              v-on:click="
                $v.newEmail.$invalid ? requiredM() : (checkEmailModal = true)
              "
              v-bind:class="$v.newEmail.$invalid ? 'inactive' : 'active'"
            >
              <i class="icon cil-envelope-closed"></i> Eメールアドレス更新
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>

      <CCol lg="6">
        <CCard>
          <CCardHeader>
            <h3 class="card-title">パスワード更新</h3>
          </CCardHeader>
          <CCardBody class="px-5">
            <CAlert show color="info">
              パスワード更新を行う場合は、下記のボタンを押してください。
              <br />本システムからパスワード更新について、ご案内メールが送信されます。
              <br />ご案内メールの記載内容に従って、パスワード更新を行ってください。
            </CAlert>
          </CCardBody>
          <CCardFooter class="px-5">
            <CButton
              class="info-button shadow-sm"
              v-on:click="submitUpdatePassword('パスワード更新')"
            >
              <i class="icon cil-lock-locked"></i> パスワード更新
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <FamilyMember />

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol>
                <h3 class="card-title">退会手続き</h3>
              </CCol>
              <!-- <CCol>
                <CButton @click="openwithdrawalModal()" color="danger"
                  ><i class="icon cil-user-follow"></i> 退会する</CButton
                >
              </CCol> -->
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol>
                <CButton @click="openwithdrawalModal()" color="danger"
                  ><i class="icon cil-user-unfollow"></i> 退会する</CButton
                >
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <!-- 退会手続きモーダル -->
    <CModal
      :show.sync="withdrawalModal"
      :closeOnBackdrop="false"
      :centered="true"
      size="xl"
      color="dark"
    >
      <template #header>
        <h5>退会手続き</h5>
      </template>
      <CForm class="modal-form p-4">
        <CRow>
          <CCol lg="12" class="px-0 mb-3">
            <h4 class="sub-title">ご利用規約</h4>
          </CCol>
        </CRow>
        <CRow>
          <CCol class="overflow-section border p-1 mb-2">
            <div class="terms_and_condition">
              <strong>【ご利用規約】</strong>
              <p>
                本規約は、株式会社リバティー（以下「弊社」といいます）の運営する施設およびWEBサイト（以下「本サービス」という）の利用条件について定めるものです。
              </p>

              <strong>第1条(会員資格)</strong>
              <p>
                入会は以下の規約に同意いただき、所定の会員登録手続きを完了された方といたします。
              </p>

              <strong>第2条(基本合意)</strong>
              <p>
                本サービスの利用については会員の責任となります。また、会員は本規約を承諾したうえで本サービスを利用するものとします。弊社が本サービス通じて随時会員に向けて発表する諸規定は、本規約の一部を構成し、会員はこれを承諾したうえで本サービスを利用するものとします。この規約は任意に変更することがあり、変更後に本サービスの利用があった場合には、会員はこの変更を承諾したものとします。<br />
              </p>

              <strong>第3条(会員)</strong>
              <p>
                1.弊社所定の登録手続きから氏名・生年月日・電話番号・メールアドレス・会員が任意に設定するパスワードなど(以下「会員情報」といいます)を弊社の定める方法に従って登録された方を会員とします。<br />
                2.会員は、登録した会員情報が真実であることを保証するものとし、弊社は、会員情報に基づいてのみ本サービスの利用を承諾するものとします。<br />
                3.次に該当する場合は、会員となることはできず、会員登録終了後においても、弊社の判断で会員資格を喪失することがあります。<br />
                (1)会員が実在しない場合<br />
                (2)過去に本規約違反などにより、会員資格の停止又は取消しが行われている場合<br />
                (3)会員情報に、虚偽の記載、誤記、又は記入漏れがあった場合<br />
                (4)弊社の業務の遂行上又は技術上支障がある場合<br />
                (5)会員が本規約に違反した場合<br />
                (6)その他、弊社が会員であることを不適当と判断した場合<br />
                4.弊社が会員に連絡、通知する場合、会員情報に登録された電話番号への連絡、メールアドレスへの送信をもって到達したものとみなします。
              </p>

              <strong>第4条(個人情報の利用目的)</strong>
              <p>
                ご登録頂いた個人情報は弊社内で共有し、ご挨拶や弊社提供の特典情報および宿泊プラン、通信販売等の新商品のご案内や、各種関連商品の販売、勧誘、広告及び宣伝物の送付、送信（電子メールを含む。）、ご案内、弊社内部における市場調査及び分析並びに商品及びアフターサービスの研究、開発及び実施のために利用いたします。
              </p>

              <strong>第5条(会員情報の取扱い)</strong>
              <p>
                1.本条にいう会員情報とは、ご登録いただいた個人情報、会員もしくは会員の代表者個人に関する氏名（フリガナを含む）、住所、電話番号、生年月日、ご職業、メールアドレス、クレジットカード情報、取引履歴、弊社に対して発生する料金の支払状況、その他届け出た情報とします。<br />
                2.本規約による義務の履行または権利行使のために、弊社は会員情報を保存し管理するものとします。<br />
                3.弊社は、本条第2項及び以下の各号に定める場合を除いて、第三者に対し会員情報の開示を行わないものとします。<br />
                (1)会員が同意する場合<br />
                (2)弊社が実施する懸賞に当選した会員に関して、当選者の氏名及び住所の存する都道府県名を公表する場合<br />
                (3)法令により開示が求められた場合<br />
                (4)本サイト上での会員の行為が、法令または利用規約等に反し、弊社の権利、財産が侵害されるおそれがある場合や、本サービスの提供に支障があると認められる場合<br />
                (5)裁判所、検察官、警察、弁護士会、消費者センターまたはこれに準じた権限を有する機関から、会員の登録内容についての開示が求められた場合<br />
                4.弊社は、会員情報の管理には最大限の努力を払いますが、万が一、第三者による故意のハッキング等により生じた情報漏洩やこれに伴い会員に生じた損害すべてに対し、いかなる責任も負わないものとします。
              </p>

              <strong>第6条(会員情報の開示・訂正・削除等)</strong>
              <p>
                弊社の定める方法に従い、会員から会員情報の利用目的の通知、開示、訂正、利用停止等の請求がある場合、弊社は請求があった会員本人もしくは会員の代表者に関するこれらの開示、修正等を行うものとします。なお、開示、訂正等の請求は以下に連絡するものとします。<br />
                連絡先メールアドレス：ask@liberty-resort.jp
              </p>

              <strong>第7条(設備等)</strong>
              <p>
                会員は、本サービスを利用するために必要な通信機器、その他の機器を自己の負担において、準備するものとします。また、自己費用で電気通信サービスを利用してサーバーへ接続するものとします。必要な手続きは会員が自己の責任と費用で行なうものとします。
              </p>

              <strong>第8条(禁止事項)</strong>
              <p>
                1.本サービスの利用に際し、会員は次号に該当する行為を行うことはできません。<br />
                (1)法令又は本規約、公序良俗に反する行為<br />
                (2)第三者の権利、利益を侵害する行為又は第三者の迷惑になる行為<br />
                (3)未成年者に対し悪影響があると判断される行為<br />
                (4)本サービスの運営を妨げ、又は、本サイトもしくは弊社の信用を毀損する行為<br />
                (5)本サービスを通じて入手した情報を私的使用目的以外の方法で利用し、又は第三者に同様の行為をさせる行為（但し、弊社が承認した場合は除く）<br />
                2.会員の行為が前項に該当すると弊社が判断した場合、弊社は会員に対し当該行為の停止を求めることができるほか、会員資格の喪失を決定することができるものとします。
              </p>

              <strong>第9条(会員間の情報)</strong>
              <p>
                1.会員は、自己の責任と良識に従って本サービスを利用するものとし、利用に際して、弊社、第三者に迷惑をかけないものとします。<br />
                2.会員同士でなされた情報の授受、およびそれに付随して行われる行為について弊社は一切責任を負わないものとします。<br />
                3.会員同士あるいは弊社と会員とでなされた情報の授受に関して、当該情報が各種WEB上のウィルス等に感染していたことにより弊社やその他の第三者が損害を蒙った場合、当該情報を掲載した会員はその損害を賠償するものとします。また、本サービスは当該損害について会員または第三者について一切責任を負わないものとします。
              </p>

              <strong>第10条(権利の帰属)</strong>
              <p>
                本サービスを通じて会員から提供された情報や作品その他のコンテンツに関する知的財産権（著作権その他のノウハウ等）は、すべて弊社に帰属するものとします。
              </p>

              <strong>第11条(本サービスの内容の変更および停止)</strong>
              <p>
                弊社は予告なく本サービスの内容の変更、利用停止または中止をすることができるものとします。この変更、停止、中止などについては、本サービスを通じて発表するものとします。この場合に会員または第三者に生じた損害については、弊社はいかなる責任も負わないものとします。
              </p>

              <strong>第12条(一時的な中断)</strong>
              <p>
                弊社は、以下の各号に該当する場合には事前に連絡することなく本サービスを一時的に中断することができるものとします。<br />
                (1)本サイトのシステムの保守、点検、修理、変更を定期的にまたは緊急に行なう場合<br />
                (2)火災、停電などにより提供ができなくなった場合<br />
                (3)地震、噴火、洪水、津波などの天災により提供ができなくなった場合<br />
                (4)戦争、変乱、暴動、騒乱、労働争議などにより提供ができなくなった場合<br />
                (5)その他、運用上、技術上本サービスが一時的な中断を必要と判断した場合
              </p>

              <strong>第13条(本サービスの内容の保証および中断)</strong>
              <p>
                弊社は、本サイトに関して提供する情報、会員が登録する情報について、そのいかなる保証も行ないません。弊社は、理由の如何を問わず、本サイトの提供の遅延または中断などが発生し、その結果会員または他の第三者が損害を被ったとしても当該損害について一切の責任を負わないものとします。
              </p>

              <strong>第14条(損害賠償)</strong>
              <p>
                1.本サービスの利用により発生した会員の損害すべてに対し、弊社はいかなる責任も負わないものとします。損害には第三者による故意のハッキング等により生じた情報漏洩を含みます。また、弊社が会員の登録、掲載した情報を削除し、会員資格を停止し、抹消し、本サービスを停止、中断、中止したことにつき、弊社は事由の如何を問わず、いかなる責任も負わないものとします。<br />
                2.会員が本サービスの利用によって他の会員や第三者に対して損害を与えた場合、会員は自己の責任と費用をもって解決し、弊社に損害を与えることのないものとします。
              </p>

              <strong>第15条(専属的合意管轄裁判所)</strong>
              <p>
                会員と弊社との間で訴訟の必要が生じた場合、静岡地方裁判所もしくは静岡簡易裁判所を専属的合意管轄裁判所とします。
              </p>

              <p>令和2年10月23日制定</p>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <!-- <div class="checkbok_overlay">
              <div>
                <CInputCheckbox :checked.sync="withdrawalAgree" />
              </div>
              <label>アカウントが削除され、ログインできなくなることに同意する。</label>
              <p>（同意にチェック後、「退会する」ボタンが表示されます。）</p>
            </div> -->

            <label class="check-inline">
              <input type="checkbox" v-model="withdrawalAgree" />
              <span>ご利用規約に同意する。</span>
            </label>

            <p>（同意にチェック後、「退会する」ボタンが表示されます。）</p>
          </CCol>

          <!-- <CCol> -->
          <!-- <div>
              <input type="checkbox" v-model="withdrawalAgree" />
              <label for="checkbox"
                >アカウントが削除され、ログインできなくなることに同意する。</label
              >
              <p>※同意にチェックを入れると「退会する」ボタンが表示されます。</p>
            </div> -->
          <!-- </CCol> -->
        </CRow>
      </CForm>
      <template #footer>
        <CButton @click="closeWithdrawalModal()" color="secondary"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
        <CButton
          v-if="withdrawalAgree"
          @click="withdrawalConfirmModal = true"
          color="danger"
          ><i class="icon cil-save"></i> 退会する</CButton
        >
      </template>
    </CModal>

    <!-- 退会手続き最終確認 -->
    <CModal
      color="warning"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="withdrawalConfirmModal"
      size="l"
    >
      <p>退会してよろしいですか？</p>
      <template #header>
        <h4>退会手続き最終確認</h4>
      </template>
      <template #footer>
        <CButton
          @click="closeWithdrawalConfirmModal()"
          color="secondary"
          class="float-left"
          ><i class="icon cil-x"></i> キャンセル</CButton
        >
        <CButton @click="withdrawalProfileRun()" color="danger"
          ><i class="icon cil-pencil"></i> 退会</CButton
        >
      </template>
    </CModal>

    <!-- 退会手続き完了 -->
    <!-- <CModal
      title="退会完了"
      color="success"
      closeOnBackdrop
      :centered="true"
      :show.sync="withdrawalCompleteModal"
      size="l"
    >
      <p>退会手続きが完了しました。</p>
      <p>ご利用ありがとうございました。</p>
      <template #header>
        <h4>退会手続き最終確認</h4>
      </template>
      <template #footer>
        <CButton
          @click="closeWithdrawalCompleteModal()"
          color="secondary"
          class="float-left"
          ><i class="icon cil-x"></i> トップへ</CButton
        >
      </template>
    </CModal> -->

    <CModal
      :show.sync="editingModal"
      :closeOnBackdrop="false"
      :centered="true"
      size="xl"
      color="dark"
    >
      <CForm class="member-info modal-form">
        <CRow>
          <CCol>
            <h4 class="sub-title">登録情報</h4>
          </CCol>
        </CRow>

        <!-- TODO: previewAvatar が空の時、this.user.picture を表示する -->
        <!-- <CRow>
          <CCol lg="6">
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3 upload-img"
                >プロフィール画像</label
              >

              <div class="col-sm-9">
                <img
                  class="avatar-img"
                  :src="avatar.previewImage"
                  v-if="avatar.previewImage"
                />
                <CInputFile
                  id="change_avatar"
                  accept="image/*"
                  @change="onAvatarChange($event)"
                />
              </div>
            </div>
          </CCol>
        </CRow> -->
        <CRow>
          <CCol lg="6">
            <CInput
              label="ユーザー名"
              horizontal
              plaintext
              required
              v-model="itemToEdit.name"
            />
          </CCol>

          <CCol lg="6">
            <CInput
              label="カードID"
              horizontal
              plaintext
              required
              v-model="itemToEdit.cardId"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.familyName.required"
            >
              氏の入力は必須です
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.familyName.maxLength"
            >
              氏は{{ limited.familyName.maxLength }}文字以下で入力してください
            </div>
            <!-- <CInput
              label="氏"
              horizontal
              required
              v-model="itemToEdit.familyName"
            /> -->

            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">氏</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="itemToEdit.familyName"
                  v-on:input="familyName_furigana"
                />
              </div>
            </div>
          </CCol>

          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.givenName.required"
            >
              名の入力は必須です
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.givenName.maxLength"
            >
              名は{{ limited.givenName.maxLength }}文字以下で入力してください
            </div>
            <!-- <CInput
              label="名"
              horizontal
              required
              v-model="itemToEdit.givenName"
            /> -->
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">名</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="itemToEdit.givenName"
                  v-on:input="givenName_furigana"
                />
              </div>
            </div>
          </CCol>
        </CRow>

        <CRow>
          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.firstName.required"
            >
              氏（カナ）の入力は必須です
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.firstName.isKana"
            >
              氏（カナ）はカタカナを入力してください
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.firstName.maxLength"
            >
              氏（カナ）は{{
                limited.firstName.maxLength
              }}文字以下で入力してください
            </div>
            <CInput
              label="氏（カナ）"
              horizontal
              required
              v-model="itemToEdit.firstName"
            />
          </CCol>

          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.lastName.required"
            >
              名（カナ）の入力は必須です
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.lastName.isKana"
            >
              名（カナ）はカタカナを入力してください
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.lastName.maxLength"
            >
              名（カナ）は{{
                limited.lastName.maxLength
              }}文字以下で入力してください
            </div>
            <CInput
              label="名（カナ）"
              horizontal
              required
              v-model="itemToEdit.lastName"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.gender.required"
            >
              性別の選択は必須です
            </div>
            <CSelect
              label="性別"
              horizontal
              :options="options.genderOptions"
              :value.sync="itemToEdit.gender"
            />
          </CCol>

          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.birth.required"
            >
              生年月日の入力は必須です
            </div>
            <CInput
              label="生年月日"
              type="date"
              horizontal
              required
              v-model="itemToEdit.birth"
            />
          </CCol>
        </CRow>

        <CRow></CRow>

        <CRow>
          <CCol>
            <h4 class="sub-title">連絡情報</h4>
          </CCol>
        </CRow>

        <CRow>
          <CCol lg="6">
            <CInput
              label="Eメールアドレス"
              horizontal
              plaintext
              required
              v-model="itemToEdit.email"
            />
          </CCol>
        </CRow>

        <!-- <CRow>
          <CCol lg="6">
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3 upload-img"
                >Eメールアドレス承認状態</label
              >

              <div class="col-sm-9">
                {{ itemToEdit.emailVerified | emailVerifiedString }}
              </div>
            </div>
          </CCol>
        </CRow> -->
        <CRow>
          <CCol lg="6">
            <CSelect
              label="国番号"
              horizontal
              :options="codeOptions"
              :value.sync="itemToEdit.countryCode"
            >
              {{ itemToEdit.countryCode }}
            </CSelect>
          </CCol>
        </CRow>
        <CRow>
          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.mobile.required"
            >
              電話番号の入力は必須です
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.mobile.numeric"
            >
              電話番号は数値を入力してください
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.mobile.maxLength"
            >
              電話番号は{{ limited.mobile.maxLength }}文字以下で入力してください
            </div>
            <CInput
              label="電話番号"
              description="ハイフン(-)は入力しないでください"
              horizontal
              required
              v-model="itemToEdit.mobile"
            />
          </CCol>
        </CRow>

        <CRow></CRow>

        <CRow>
          <CCol>
            <h4 class="sub-title">住所</h4>
          </CCol>
        </CRow>

        <CRow>
          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.address.country.required"
            >
              国の選択は必須です
            </div>
            <CSelect
              label="国"
              horizontal
              :options="countryOptions"
              :value.sync="itemToEdit.address.country.id"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.address.zipCode.required"
            >
              郵便番号の入力は必須です
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.address.zipCode.maxLength"
            >
              郵便番号は{{
                limited.address.zipCode.maxLength
              }}文字以下で入力してください
            </div>
            <CInput
              label="郵便番号"
              horizontal
              required
              v-model="itemToEdit.address.zipCode"
            />
          </CCol>
          <CCol lg="4">
            <CButton color="success" @click="getAddress()"
              ><i class="icon cil-location-pin"></i> 住所自動入力</CButton
            >
          </CCol>
        </CRow>
        <CRow>
          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.address.state.required"
            >
              都道府県の入力は必須です
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.address.state.maxLength"
            >
              都道府県は{{
                limited.address.state.maxLength
              }}文字以下で入力してください
            </div>
            <CInput
              label="都道府県"
              horizontal
              required
              v-model="itemToEdit.address.state"
            />
          </CCol>
          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.address.city.required"
            >
              市区町村の入力は必須です
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.address.city.maxLength"
            >
              市区町村は{{
                limited.address.city.maxLength
              }}文字以下で入力してください
            </div>
            <CInput
              label="市区町村"
              horizontal
              required
              v-model="itemToEdit.address.city"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.address.address1.required"
            >
              地番番地の入力は必須です
            </div>
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.address.address1.maxLength"
            >
              地番番地は{{
                limited.address.address1.maxLength
              }}文字以下で入力してください
            </div>
            <CInput
              label="地番番地"
              horizontal
              required
              v-model="itemToEdit.address.address1"
            />
          </CCol>

          <CCol lg="6">
            <div
              class="text-danger input-info"
              v-if="!$v.itemToEdit.address.address2.maxLength"
            >
              建物・その他は{{
                limited.address.address2.maxLength
              }}文字以下で入力してください
            </div>
            <CInput
              label="建物・その他"
              horizontal
              required
              v-model="itemToEdit.address.address2"
            />
          </CCol>
        </CRow>
      </CForm>
      <template #header>
        <h6 class="modal-title">会員情報編集</h6>
      </template>
      <template #footer>
        <CButton @click="cancelEditProfile()" color="secondary"
          ><i class="icon cil-x"></i> キャンセル</CButton
        >
        <CButton
          @click="saveProfile()"
          color="success"
          :disabled="$v.itemToEdit.$invalid"
          ><i class="icon cil-save"></i> 保存</CButton
        >
      </template>
    </CModal>

    <CModal
      :show.sync="ConfirmModal"
      :no-close-on-backdrop="true"
      :centered="true"
      :title="ModalTitle"
      size="m"
      color="dark"
    >
      <!-- パスワード更新 -->
      <div class="modal-body px-2">
        <p>
          {{
            ModalTitle
          }}のEメールアドレスを登録したEメールアドレスに送信しました。
          <br />Eメールアドレスを確認してリンクに従って更新してください。
        </p>
      </div>
      <template #header>
        <h6 class="modal-title">{{ ModalTitle }}</h6>
      </template>
      <template #footer>
        <CButton @click="ConfirmModal = false" color="danger">閉じる</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="checkEmailModal"
      :closeOnBackdrop="false"
      :centered="true"
      size="m"
      color="dark"
    >
      <!-- メール更新確認 -->
      <div class="modal-body px-2">
        <p>
          メールアドレスは<b class="mx-1">{{ newEmail }}</b
          >に変更してよろしでしょうか

          <CAlert color="info"
            >変更してから新たなメールアドレスに認証メールを送信しますから、ご確認のほどお願い致します。</CAlert
          >
        </p>
        <!-- <b>agree: {{changeUserNameAgree}}</b>
        <b>email: {{isUserEmail}}</b> -->
        <!-- v-if="!isUserEmail" -->
        <label class="check-inline grey-bg">
          <input type="checkbox" v-model="changeUserNameAgree" />
          <span
            >ユーザー名も<b class="mx-1">{{ newEmail }}</b
            >に変更します
          </span>
        </label>
        <!-- CAlert color="warning">ユーザー名を変更してから自動的にログアウトして、再びログインが必須です</!-->
      </div>
      <template #header>
        <h6 class="modal-title">Eメールアドレス更新確認</h6>
      </template>
      <template #footer>
        <CButton @click="checkEmailModal = false" color="danger"
          >キャンセル</CButton
        >
        <CButton @click="submitUpdateEmail()" color="success">変更</CButton>
      </template> </CModal
    ><CModal
      :show.sync="ConfirmEmailModal"
      :closeOnBackdrop="false"
      :centered="true"
      size="m"
      color="dark"
    >
      <!-- メールアドレス更新 -->
      <div class="modal-body px-2">
        <p>
          メールアドレスを更新できました
          <br />新たなメールアドレスに認証メールを送信しましたから、ご確認のほどお願い致します。
        </p>
        <!--CAlert color="warning" v-if="!changeUserNameAgree" >ユーザー名も変更されたのでログアウトします。再度ログインしてください。
          </!--CAlert-->
      </div>
      <template #header>
        <h6 class="modal-title">Eメールアドレス更新完了</h6>
      </template>
      <template #footer>
        <CButton @click="closeMailUpdateModal()" color="danger">閉じる</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="ConfirmPassUpdateModal"
      :closeOnBackdrop="false"
      :centered="true"
      :title="ModalTitle"
      size="m"
      color="dark"
    >
      <!-- パスワード更新 -->
      <div class="modal-body px-2">
        <p>登録されたEメールアドレスにパスワード更新のリンクを送信しました。</p>
      </div>
      <template #header>
        <h6 class="modal-title">{{ ModalTitle }}</h6>
      </template>
      <template #footer>
        <CButton @click="ConfirmPassUpdateModal = false" color="danger"
          >閉じる</CButton
        >
      </template>
    </CModal>

    <CModal
      color="success"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="successModal"
    >
      更新が完了しました。
      <template #header> 更新完了 </template>
      <template #footer>
        <CButton @click="successModal = false" color="secondary">
          <i class="icon cil-x"></i> 閉じる
        </CButton>
      </template>
    </CModal>
    <CModal
      color="danger"
      closeOnBackdrop
      :centered="true"
      :show.sync="errorModal"
    >
      <p>{{ errorMessage }}</p>
      <template #header>
        <h4 class="modal-title">Error</h4>
      </template>
      <template #footer>
        <CButton @click="errorModal = false" color="secondary">
          <i class="icon cil-x"></i> 閉じる
        </CButton>
      </template>
    </CModal>
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import {
  required,
  maxLength,
  numeric,
  helpers,
} from "vuelidate/lib/validators";
import FamilyMember from "../components/FamilyMember";
import Options from "../components/Options";

import historykana from "historykana";
import * as wanakana from "wanakana";
const alphaEmailValidator = helpers.regex(
  "alphaEmail",
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
const avatar_url =
  "https://gaa9xd7j0g.execute-api.ap-northeast-1.amazonaws.com/develop";
const zipcode_url =
  "https://jxamy7mdqg.execute-api.ap-northeast-1.amazonaws.com/api/";

const limited = {
  familyName: { maxLength: 100 },
  givenName: { maxLength: 100 },
  firstName: { maxLength: 100 },
  lastName: { maxLength: 100 },
  mobile: { maxLength: 20 },
  address: {
    zipCode: { maxLength: 10 },
    state: { maxLength: 255 },
    city: { maxLength: 255 },
    address1: { maxLength: 255 },
    address2: { maxLength: 255 },
  },
};

export default {
  components: {
    FamilyMember,
  },
  name: "Profile",
  data() {
    return {
       
      furigana: "",
      newEmail: "",
      history: [],
      ModalTitle: "",
      errorMessage: "",
      editingModal: false,
      ConfirmModal: false,
      ConfirmEmailModal: false,
      checkEmailModal: false,
      ConfirmPassUpdateModal: false,
      successModal: false,
      errorModal: false,
      withdrawalModal: false,
      withdrawalAgree: false,
      changeUserNameAgree: false,
      withdrawalConfirmModal: false,
      withdrawalCompleteModal: false,
      engFirstName: true,
      engLastName: true,
      isUserEmail: false,
      codeOptions: [],
      countryOptions: [],
      options: Options.data(),
      user: {
        firstName: "",
        lastName: "",
        familyName: "",
        givenName: "",
        gender: "",
        birth: "",
        userName: "",
        cardId: "",
        email: "",
        emailVerified: true,
        countryCode: "",
        mobile: "",
        address: {
          state: "",
          city: "",
          address1: "",
          address2: "",
          zipCode: "",
          country: {
            id: "",
            name: "",
            fullName: "",
            alpha2: "",
            alpha3: "",
            dial: "",
            flagData: "",
          },
        },
        picture: "",
      },
      itemToEdit: {
        firstName: "",
        lastName: "",
        familyName: "",
        givenName: "",
        gender: "",
        birth: "",
        userName: "",
        countryCode: "",
        mobile: "",
        address: {
          state: "",
          city: "",
          address1: "",
          address2: "",
          zipCode: "",
          country: {
            id: "",
            name: "",
            fullName: "",
            alpha2: "",
            alpha3: "",
            dial: "",
            flagData: "",
          },
        },
        picture: "",
      },
      avatar: {
        image: "",
        previewImage: "",
        type: "",
      },
      limited: limited,
    };
  },
  validations() {
    const isKana = helpers.regex("isKana", /^([ァ-ヴ][ァ-ヴー・]*)$/);

    return {
      withdrawalModal: {
        required: { allowFalse: false },
      },
      itemToEdit: {
        familyName: {
          required,
          maxLength: maxLength(limited.familyName.maxLength),
        },
        givenName: {
          required,
          maxLength: maxLength(limited.givenName.maxLength),
        },
        firstName: {
          required,
          isKana: this.engFirstName ? false : isKana,
          maxLength: maxLength(limited.firstName.maxLength),
        },
        lastName: {
          required,
          isKana: this.engLastName ? false : isKana,
          maxLength: maxLength(limited.lastName.maxLength),
        },
        gender: { required },
        birth: { required },
        mobile: {
          required,
          numeric,
          maxLength: maxLength(limited.mobile.maxLength),
        },
        address: {
          country: { required },
          zipCode: {
            required,
            maxLength: maxLength(limited.address.zipCode.maxLength),
          }, // Note: US9桁
          state: {
            required,
            maxLength: maxLength(limited.address.state.maxLength),
          },
          city: {
            required,
            maxLength: maxLength(limited.address.city.maxLength),
          },
          address1: {
            required,
            maxLength: maxLength(limited.address.address1.maxLength),
          },
          address2: {
            maxLength: maxLength(limited.address.address2.maxLength),
          },
        },
      },
      newEmail: { required, alphaEmailValidator, maxLength: maxLength(100) },
    };
  },
  filters: {
    genderString: function (value) {
      if (!value) return "公開しない";
      var retString;
      switch (value) {
        case "UNKONWN":
          retString = "公開しない";
          break;
        case "MALE":
          retString = "男性";
          break;
        case "FEMALE":
          retString = "女性";
          break;
        default:
          retString = "未知";
          break;
      }
      return retString;
    },
    emailVerifiedString: function (value) {
      if (!value) return "不明";
      switch (value) {
        case true:
          return "承認済み";
        case false:
          return "未承認";
        default:
          return "不明";
      }
    },
  },

  methods: {
    getUserInformation: function () {
      //Login as registered user
      var urlRequest = "/rest/currentuser";
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.user = resp.data;
          console.log("User Data:" + JSON.stringify(this.user));
          FamilyMember.methods.setFullName(this.fullName);
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          this.isUserEmail = re.test(String(this.user.name).toLowerCase());
          this.isUserEmail
            ? (this.changeUserNameAgree = true)
            : (this.changeUserNameAgree = false);
          // this.downloadAvatar();
        })
        .catch((err) => {
           

          console.log(err);
        });
    },
    getCountries: function () {
      //Login as registered user
      var urlRequest = "/rest/country";
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("getCountries:" + JSON.stringify(resp.data));

          this.countryOptions = [];
          this.codeOptions = [];
          resp.data.forEach((element) => {
            this.countryOptions.push({
              value: element.id,
              label: element.name,
            });
            // 国際電話の国番号をセット
            this.codeOptions.push({
              value: element.dial,
              label: element.name + " (" + element.dial + ")",
            });
          });
        })
        .catch((err) => {
           

          console.log(err);
        });
    },
    openEditDialog() {
      this.resetProfile();
      this.getCountries();
      this.editingModal = true;
    },
    saveProfile: async function () {
      // 更新があればプロフィール画像登録を行う
      if (this.avatar.type != "") await this.uploadAvatar();

      const urlRequest = "/rest/users/" + this.$keycloak.userName;

      console.log("Request Data:" + JSON.stringify(this.itemToEdit));
      axios
        .put(urlRequest, this.itemToEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          this.editingModal = false;
          this.getUserInformation();
          this.successModal = true;
        })
        .catch((err) => {
           

          console.log("Updating profile error: " + err);
          this.errors = err;
          this.errorModal = true;
        });
    },
    // get date information
    getDateString: function (dateItem) {
      var today;
      if (dateItem) {
        today = new Date(dateItem);
      } else {
        today = new Date();
      }

      var dateString =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      return dateString;
    },
    // update password post
    submitUpdatePassword: function (title) {
      this.ModalTitle = title;
      var userInfo = {
        username: this.$keycloak.userName,
        password: "",
      };
      // Confirm current password & update password.
      var urlRequest = "/rest/users/" + this.$keycloak.userName + "/password";
      axios
        .post(urlRequest, userInfo, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp);
          this.ConfirmPassUpdateModal = true;
        })
        .catch((err) => {
           

          this.errorMessage = err;
          this.errorModal = true;
          // alert("パスワード更新要求はエラーが発生しました：" + err);
        });
    },
    // put email updated
    submitUpdateEmail: function () {
      var userInfoE = {
        username: this.$keycloak.userName,
        email: this.newEmail,
        changeUsername: this.changeUserNameAgree, // fix it for change username as email
      };
      var urlRequestE = "/rest/users/" + this.$keycloak.userName + "/email";
      axios
        .put(urlRequestE, userInfoE, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp);
          this.checkEmailModal = false;
          this.ConfirmEmailModal = true;
          // this.getUserInformation();
          this.newEmail = "";
        })
        .catch((err) => {
           

          this.errorMessage = err;
          this.errorModal = true;
          // alert("Error更新要求はエラーが発生しました：" + err);
          // location.reload();
        });
    },
    onAvatarChange: function (e) {
      // CInputFile の場合
      const files = e;

      this.avatar.type = files[0].type;
      console.log("this.avatar.type: " + this.avatar.type);

      this.getBase64(files[0])
        .then((avatar) => (this.avatar.previewImage = avatar))
        .catch((error) =>
          this.setError(error, "画像のアップロードに失敗しました。")
        );
    },
    getBase64: function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    getAddress: function () {
      // Get address by zipcode
      const urlRequest =
        zipcode_url + "?postcode=" + this.itemToEdit.address.zipCode;

      axios
        .get(urlRequest)
        .then((resp) => {
          console.log("resp.data: ", resp.data);
          this.itemToEdit.address.state = resp.data.PrefecturesName;
          this.itemToEdit.address.city =
            resp.data.CityName + resp.data.TownName;
        })
        .catch((err) => {
           
          console.log(err);
        });
    },
    cancelEditProfile: function () {
      // 会員情報編集画面を閉じる
      this.resetProfile();
      this.editingModal = false;
    },
    resetProfile: function () {
      // 入力内容をリセット
      // note: Object.assign() は itemToEdit が user の参照になってしまうため却下
      //   例) this.itemToEdit = Object.assign({}, this.user);
      // note: スプレッド構文は、ネストしたオブジェクトが参照になるため却下
      //   例）this.itemToEdit = { ...this.user };
      //
      this.itemToEdit = JSON.parse(JSON.stringify(this.user));

      this.avatar.previewImage = this.avatar.image;
      this.avatar.type = "";
    },
    uploadAvatar: async function () {
      const urlRequest = avatar_url;
      const header = { headers: { ContentType: this.avatar.type } };
      // todo: ここでリサイズ処理が必要（100x100など）
      // todo-memo: 2020/09/25時点で resize-base64(動かない), sharp(node v12は動かない?), canvas(よくわからない)
      const original = this.avatar.previewImage.replace(
        /^data:\w+\/\w+;base64,/,
        ""
      );

      await axios
        .put(urlRequest, original, header)
        .then((resp) => {
          console.log("uploadAvatar:");
          console.log(resp.data);
          this.itemToEdit.picture = resp.data.key;
        })
        .catch((err) => {
           

          console.log("Upload avatar error: " + err);
          this.errors = err;
        });
    },
    downloadAvatar: function () {
      const key = this.user.picture;
      const urlRequest = avatar_url + "?key=" + key;
      const type = String(key).slice(".")[1]; // 拡張子を取得

      axios
        .get(urlRequest)
        .then((resp) => {
          console.log(resp);
          this.avatar.image = "data:image/" + type + ";base64," + resp.data;
          this.avatar.previewImage = this.avatar.image;
        })
        .catch((err) => {
           

          console.log("Download avatar error: " + err);
          this.errors = err;
        });
    },

    /**
     * 退会内容モーダル表示
     */
    openwithdrawalModal: function () {
      this.withdrawalAgree = false;
      this.withdrawalModal = true;
    },

    /**
     * 退会内容確認モーダル閉じる
     */
    closeWithdrawalModal: function () {
      this.withdrawalModal = false;
    },

    /**
     * 退会最終確認モーダル閉じる
     */
    closeWithdrawalConfirmModal: function () {
      this.withdrawalConfirmModal = false;
      this.closeWithdrawalModal();
    },

    /**
     * 退会最終確認モーダル退会押下
     */
    withdrawalProfileRun: function () {
      this.withdrawalModal = false;
      this.withdrawalConfirmModal = false;
      var urlRequest;
      urlRequest = "/rest/users/" + this.user.name + "/status";
      console.log(this.user.name);
      axios
        .put(
          urlRequest,
          { enabled: false },
          {
            headers: { Authorization: `Bearer ${this.$keycloak.token}` },
          }
        )
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          //this.getUserInformation();
          this.$router.push("/logout");
        })
        .catch((err) => {
           

          // this.completedModal = true;
          // this.memberFormReset();
          // this.scrollTop();
          console.log("Updating profile error: " + err);
          this.errors = err;
        });
    },

    /**
     *退会完了モーダルトップへボタン押下
     */
    // closeWithdrawalCompleteModal:function(){
    //   this.$router.push('/dashboard');
    // },

    // TODO: 仕様確認
    /**
     * カードID編集ボタンクリック
     */
    onCardIdEditClick() {
      this.editCardIdModal = true;
    },
    requiredM() {
      this.$v.newEmail.$touch();
    },
    familyName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.firstName = input.target.value;
        this.engFirstName = true;
      } else {
        this.engFirstName = false;
        this.history.push(input.target.value);
        this.itemToEdit.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    givenName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.lastName = input.target.value;
        this.engLastName = true;
      } else {
        this.engLastName = false;
        this.history.push(input.target.value);
        this.itemToEdit.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    closeMailUpdateModal() {
      this.changeUserNameAgree ? this.$router.go() : this.getUserInformation();
      this.ConfirmEmailModal = false;
    },
  },
  beforeMount() {
    this.getUserInformation();
  },
  computed: {
    fullName() {
      return this.user.familyName + " " + this.user.givenName;
    },
  },
};
</script>
